export default "__VITE_ASSET__BBd2H$oG__"